/*
 * @Description: 批次流入信息
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2020-12-02 16:15:05
 * @LastEditTime: 2020-12-04 18:35:04
 */
import request from "_private/utils/request";

// 根据类型查询企业列表 1-食品经营 2-仓库园区 4-物流运输
export function fetchCorpListByType(type) {
  return request({
    url: "/coldTrace/companyListByType",
    method: "get",
    headers: { type: "json" },
    params: {
      companyType: type
    }
  });
}

// 请求批次流入信息列表
export function fetchFindFlowInByPage(data) {
  return request({
    url: "/coldTrace/flowIn",
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 导出批次流入信息
export function fetchFlowInExport(data) {
  return request({
    url: "/coldTrace/exportFlowIn",
    method: "post",
    responseType: "blob",
    headers: { type: "json" },
    data
  });
}

// 请求批次流入信息列表
export function fetchFindFlowOutByPage(data) {
  return request({
    url: "/coldTrace/flowOut",
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 批次流入概要信息
export function fetchInFlowSummary(data) {
  return request({
    url: "/coldTrace/flowInSummary",
    method: "post",
    headers: { type: "json" },
    data
  });
}

// 导出批次流出信息
export function fetchFlowOutExport(data) {
  return request({
    url: "/coldTrace/exportFlowOut",
    method: "post",
    responseType: "blob",
    headers: { type: "json" },
    data
  });
}

// 批次流出概要信息
export function fetchOutFlowSummary(data) {
  return request({
    url: "/coldTrace/flowOutSummary",
    method: "post",
    headers: { type: "json" },
    data
  });
}
